import React from "react";
import ReactDOM from "react-dom";
import { I18nextProvider } from "react-i18next";

// isomorphic-fetch overrides the global fetch. Importing this way allows it to also be mocked with jest-fetch-mock
import "isomorphic-fetch";

import { LevelsContextProvider } from "@braze/beacon-core";

// eslint-disable-next-line local-eslint-rules/no-direct-dashboard-config-access
import config from "@lib/dashboardConfig";
import { FetchRequestError } from "@lib/errors";

// eslint-disable-next-line local-eslint-rules/enforce-namespace-modularity
import { AsyncConfirmationModalProvider } from "@services/useAsyncConfirmationModal";
// eslint-disable-next-line local-eslint-rules/enforce-namespace-modularity
import { ConfirmationModal } from "@services/useConfirmationModal";

// eslint-disable-next-line local-eslint-rules/enforce-namespace-modularity
import { PlatformThemeProvider } from "@components/PlatformThemeProvider";

import i18n from "../../i18n";
import { ConfirmImpersonationFetch } from "./utils/ConfirmImpersonationFetch";
import { allowRequest } from "./utils/allowRequest";
import { CANCELED_BY_USER } from "./constants";

export const impersonationFetch = async (url: string, fetchOptions: RequestInit) => {
  const confirmOnImpersonation = config?.i && !config?.roi && config?.features?.impersonation_confirmation_modal;
  if (!confirmOnImpersonation) {
    return fetch(url, fetchOptions);
  }

  if (allowRequest(url, fetchOptions)) {
    return fetch(url, fetchOptions);
  }

  console.warn("[RequestInterceptor]", "fetch params", url, fetchOptions);
  const container = document.createElement("div");
  container.style.position = "fixed";
  container.style.width = "100vw";
  container.style.height = "100vh";
  container.style.zIndex = "99999999";
  // render a confirmation modal to ensure the developer's intent is to modify production data
  const confirmationPromise = new Promise((resolve) => {
    ReactDOM.render(
      <PlatformThemeProvider>
        <I18nextProvider i18n={i18n}>
          <LevelsContextProvider step={2} base={99999999} level={99999999}>
            <ConfirmationModal>
              <AsyncConfirmationModalProvider>
                <ConfirmImpersonationFetch resolve={resolve} url={url} />
              </AsyncConfirmationModalProvider>
            </ConfirmationModal>
          </LevelsContextProvider>
        </I18nextProvider>
      </PlatformThemeProvider>,
      container
    );
  });

  const confirmed = await confirmationPromise;

  if (confirmed) {
    return fetch(url, fetchOptions);
  }
  throw new FetchRequestError(500, CANCELED_BY_USER);
};
